<template>
    <div style="height: 100%;overflow: auto">
        <div class="head-container">
            <div style="margin-top: 10px">
                <div class="form-label" v-if="showStoreQuery">
                    <span>所属门店：</span>
                </div>
                <div class="form-input" v-if="showStoreQuery">
                    <Select v-model="formParam.storeId" filterable clearable style="width: 260px">
                        <Option v-for="item in storeList" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </div>
                <div class="form-label">
                    <span>姓  名：</span>
                </div>
                <div class="form-input" style="width: 150px">
                    <Input v-model="formParam.name"/>
                </div>
                <div class="form-label">
                    <span>电话号码：</span>
                </div>
                <div class="form-input" style="width: 150px">
                    <Input v-model="formParam.phone"/>
                </div>
                <Button type="primary" icon="md-search"
                        @click="onQuery" style="margin-right: 10px">查询
                </Button>
                <Button icon="md-refresh" @click="reset" style="margin-right: 20px">重置</Button>
            </div>
        </div>
        <div class="button-container">
            <Button type="primary" icon="md-add" style="margin-right: 20px" @click="onShowModal">新增会员</Button>
        </div>
        <div class="table-container">
            <Table :columns="columns" :data="tableData">
                <template #action="{ row, index }">
                    <span class="table-button-edit"
                          style="margin-right: 5px"
                          v-if="merchantInfo.merchantType === 2"
                          @click="newOrder(row)">
                        添加护理单
                    </span>
                    <span class="table-button-edit" style="margin-right: 5px" @click="edit(row)">编辑</span>
                    <span class="table-button-edit" style="margin-right: 8px" @click="recharge(row)">充值</span>
                    <span class="table-button-remove" @click="charge(row)">扣款</span>

                    <!--                    <Poptip-->
                    <!--                        confirm-->
                    <!--                        title="确定删除?"-->
                    <!--                        @on-ok="remove(row)" placement="top-start" transfer>-->
                    <!--                        <span class="table-button-remove">删除</span>-->
                    <!--                    </Poptip>-->
                </template>
            </Table>
            <div style="margin-top: 10px;text-align: right">
                <Page v-model="formParam.current" :page-size="formParam.size"
                      :total="formParam.total"
                      @on-change="onPageChange"
                      @on-page-size-change="onPageSizeChange"
                      show-sizer show-elevator show-total/>
            </div>
        </div>
        <Modal
            v-model="modal"
            title="新增会员"
            width="800"
            footer-hide>
            <div>
                <Form :model="formItem" :label-width="80" ref="formItem" :rules="rules" inline>
                    <FormItem label="姓  名" prop="name" class="my-form-item">
                        <Input v-model="formItem.name" placeholder="请输入姓名" class="my-form-input"></Input>
                    </FormItem>
                    <FormItem label="手机号" prop="phone" class="my-form-item">
                        <Input v-model="formItem.phone" placeholder="手机号" class="my-form-input"></Input>
                    </FormItem>
                    <FormItem label="性  别" prop="gender" class="my-form-item">
                        <Select v-model="formItem.gender" filterable class="my-form-input">
                            <Option value="1" key="1">男</Option>
                            <Option value="2" key="2">女</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="生   日" prop="birthday" class="my-form-item">
                        <DatePicker v-model="formItem.birthday" type="date" placeholder="请选择生日" class="my-form-input"/>
                    </FormItem>
                    <FormItem label="所属门店" prop="storeId"
                              v-if="showStore" class="my-form-item">
                        <Select v-model="formItem.storeId" filterable class="my-form-input">
                            <Option v-for="item in storeList" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                </Form>
                <div slot="footer" style="text-align: right">
                    <Button style="margin-right: 10px" type="primary" :loading="loading" @click="handleOk">确定</Button>
                    <Button @click="handleCancel">取消</Button>
                </div>
            </div>
        </Modal>
        <Modal
            v-model="rechargeModal"
            title="充值"
            width="500"
            footer-hide>
            <div>
                <Form :model="formItem" :label-width="80" ref="formRecharge" :rules="rechargeRules">
                    <FormItem label="姓  名" class="my-form-item" style="margin-bottom: 10px">
                        <span class="my-form-input">{{ formItem.name }}</span>
                    </FormItem>
                    <FormItem label="当前余额" class="my-form-item" style="margin-bottom: 10px">
                        <span class="my-form-input">￥{{ Number(curBalance).toFixed(2) }}</span>
                    </FormItem>
                    <FormItem label="充值金额" prop="balance" class="my-form-item" style="margin-bottom: 10px">
                        <Input type="number" v-model="formItem.balance" placeholder="充值金额" class="my-form-input"></Input>
                    </FormItem>
                </Form>
                <div slot="footer" style="text-align: right">
                    <Button style="margin-right: 10px" type="primary" :loading="loading" @click="handleRechargeOk">确定</Button>
                    <Button @click="handleRechargeCancel">取消</Button>
                </div>
            </div>
        </Modal>
        <Modal
            v-model="chargeModal"
            title="扣款"
            width="500"
            footer-hide>
            <div>
                <Form :model="formItem" :label-width="80" ref="formCharge" :rules="chargeRules">
                    <FormItem label="姓  名" class="my-form-item" style="margin-bottom: 10px">
                        <span class="my-form-input">{{ formItem.name }}</span>
                    </FormItem>
                    <FormItem label="当前余额" class="my-form-item" style="margin-bottom: 10px">
                        <span class="my-form-input">￥{{ Number(curBalance).toFixed(2) }}</span>
                    </FormItem>
                    <FormItem label="本次扣款" prop="balance" class="my-form-item" style="margin-bottom: 10px">
                        <Input type="number" v-model="formItem.balance" placeholder="本次扣款" class="my-form-input"></Input>
                    </FormItem>
                </Form>
                <div slot="footer" style="text-align: right">
                    <Button style="margin-right: 10px" type="primary" :loading="loading" @click="handleChargeOk">确定</Button>
                    <Button @click="handleChargeCancel">取消</Button>
                </div>
            </div>
        </Modal>
        <Modal
            v-model="orderModal"
            fullscreen
            :closable="false"
            footer-hide>
            <div style="height: 100%">
                <facial-order-info
                    v-if="orderModal"
                    :member-input="this.formItem"
                    :is-new="true"
                    @handleEditClose="handleEditClose"
                ></facial-order-info>
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    queryStoreList, saveMember, queryMemberPage, removeMember, recharge, charge,
} from "@/api"

import FacialOrderInfo from "@/components/Facial/FacialOrderInfo"

export default {
    name: "MemberManage",
    components: {
        FacialOrderInfo,
    },
    data() {
        return {
            merchantInfo: {},
            formParam: {
                name: '',
                idCard: '',
                phone: '',
                storeId: '',
                total: 0,
                current: 1,
                size: 10,
            },
            formItem: {
                name: '',
                account: '',
                phone: '',
                gender: '',
                age: '',
                idCard: '',
                birthday: '',
                password: '',
                merchantId: '',
                storeId: '',
                balance: 0,
            },
            columns: [
                {
                    title: '姓名',
                    key: 'name',
                    align: 'left',
                    width: 100,
                },
                {
                    title: '手机号',
                    key: 'phone',
                    align: 'center',
                },
                {
                    title: '余额',
                    key: 'balance',
                    align: 'center',
                    render: this.renderBalance,
                },
                {
                    title: '生日',
                    key: 'birthday',
                    align: 'center',
                },
                {
                    title: '修改时间',
                    key: 'updateTime',
                    align: 'center',
                    width: 180,
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 280,
                    align: 'center',
                },
            ],
            rules: {
                name: [
                    {required: true, message: '姓名不能为空', trigger: 'blur'},
                ],
                phone: [
                    {required: true, message: '手机号不能为空', trigger: 'blur'},
                ],
                storeId: [
                    {required: true, message: '门店不能为空', trigger: 'blur'},
                ],
            },
            rechargeRules: {
                balance: [
                    {required: true, message: '充值金额不能为空', trigger: 'blur'},
                ],
            },
            chargeRules: {
                balance: [
                    {required: true, message: '扣款金额不能为空', trigger: 'blur'},
                ],
            },
            curBalance: 0,
            loading: false,
            modal: false,
            rechargeModal: false,
            chargeModal: false,
            orderModal: false,
            storeList: [],
            showStore: false,
            showStoreQuery: false,
            userInfo: {},
            tableData: [],
            isNew: true,
        }
    },
    created() {
        this.userInfo = JSON.parse(sessionStorage.getItem('current-user'))
        this.merchantInfo = JSON.parse(sessionStorage.getItem('merchantInfo'))
        this.initShowInfo()
    },
    mounted() {
        this.onQuery()
    },
    methods: {
        async initShowInfo() {
            if (this.userInfo.userType === 1) {
                this.showStore = false
                this.showStoreQuery = false
            } else {
                await this.queryStoreList()
            }
        },
        handleEditClose() {
            this.orderModal = false
        },
        onQuery() {
            queryMemberPage(this.formParam).then((res) => {
                if (res.data != null) {
                    this.tableData = res.data
                    this.formParam.current = res.current
                    this.formParam.total = res.total
                }
            })
        },
        reset() {
            this.formParam = {
                name: '',
                idCard: '',
                phone: '',
                merchantId: '',
                storeId: '',
                total: 0,
                current: 1,
                size: 10,
            }
        },
        renderBalance(h, param) {
            let balance = param.row.balance
            return h('span', '￥' + Number(balance).toFixed(2))
        },
        onShowModal() {
            this.formItem = {
                name: '',
                account: '',
                phone: '',
                gender: '',
                age: '',
                idCard: '',
                birthday: '',
                password: '',
                merchantId: '',
                storeId: '',
                balance: 0,
            }
            this.isNew = true
            this.modal = true
        },
        async queryStoreList() {
            let {data} = await queryStoreList()
            this.storeList = data
            if (this.userInfo.storeId) {
                this.showStore = false
                if (this.userInfo.adminType == 2) {
                    this.showStoreQuery = true
                } else {
                    this.showStoreQuery = false
                }
            } else {
                this.showStore = true
            }
        },
        handleOk() {
            this.loading = true
            this.$refs.formItem.validate((valid) => {
                if (valid) {
                    saveMember(this.formItem).then(() => {
                        this.modal = false
                        this.$Message.success({
                            background: true,
                            content: '保存完成',
                        })
                        this.onQuery()
                    }).finally(() => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                }
            })
        },
        handleCancel() {
            this.modal = false
        },
        edit(row) {
            this.formItem = Object.assign({}, row)
            this.formItem.merchantId = row.merchantId + ''
            this.isNew = false
            this.modal = true
        },
        recharge(row) {
            this.formItem = Object.assign({}, row)
            this.curBalance = this.formItem.balance
            this.formItem.balance = ''
            this.formItem.merchantId = row.merchantId + ''
            this.isNew = false
            this.rechargeModal = true
        },
        charge(row) {
            this.formItem = Object.assign({}, row)
            this.curBalance = this.formItem.balance
            this.formItem.balance = ''
            this.formItem.merchantId = row.merchantId + ''
            this.isNew = false
            this.chargeModal = true
        },
        newOrder(row) {
            this.formItem = Object.assign({}, row)
            this.orderModal = true
        },
        handleRechargeOk() {
            this.loading = true
            this.$refs.formRecharge.validate((valid) => {
                if (valid) {
                    recharge(this.formItem).then(() => {
                        this.rechargeModal = false
                        this.$Message.success({
                            background: true,
                            content: '充值完成',
                        })
                        this.onQuery()
                    }).finally(() => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                }
            })
        },
        handleRechargeCancel() {
            this.rechargeModal = false
        },
        handleChargeOk() {
            this.loading = true
            this.$refs.formCharge.validate((valid) => {
                if (valid) {
                    charge(this.formItem).then(() => {
                        this.chargeModal = false
                        this.$Message.success({
                            background: true,
                            content: '扣款完成',
                        })
                        this.onQuery()
                    }).finally(() => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                }
            })
        },
        handleChargeCancel() {
            this.chargeModal = false
        },
        async remove(row) {
            await removeMember(row)
            await this.onQuery()
        },
        onPageChange(e) {
            this.formParam.current = e
            this.onQuery()
        },
        onPageSizeChange(e) {
            this.formParam.current = 1
            this.formParam.size = e
            this.onQuery()
        },
    },
}
</script>

<style scoped>
.form-label {
    display: inline-block;
    font-weight: bold;
    margin-left: 10px;
}

.form-input {
    display: inline-block;
    width: auto;
    margin-right: 15px;
}

.head-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.button-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.form-button {
    display: inline-block;
    width: 100%;
    text-align: left;
    margin-top: 20px;
    margin-left: 10px;
}

.my-form-item {
    margin-left: 20px;
}

.my-form-input {
    width: 260px;
}

.table-container {
    margin: 10px;
}

.role-container {
    position: relative;
    display: inline-block;
    width: 220px;
    border: 1px solid #97a8be;
    padding: 15px 10px 10px 10px;
    vertical-align: top;
}

.menu-container {
    position: relative;
    display: inline-block;
    width: 220px;
    border: 1px solid #97a8be;
    margin-left: 20px;
    padding: 15px 10px 10px 10px;
}

.type-title {
    position: absolute;
    left: 10px;
    top: -10px;
    background: white;
    padding: 0 5px;
    font-weight: bold;
}

.tree-container {
    max-height: 460px;
    overflow: auto;
    margin-bottom: 10px;
    padding-top: 10px;
}
</style>
